import type { IReportTable } from '~/presentation/reports/common/Visualization/types';

import { EReportDataType } from '~/presentation/reports/common/Visualization/types';

export const mockTableData: IReportTable = {
  columns: [
    {
      name: 'session_device_type',
      dataType: EReportDataType.STRING,
      displayName: 'Session device type',
    },
    {
      name: 'month',
      dataType: EReportDataType.STRING,
      displayName: 'Month',
    },
    {
      name: 'session_country',
      dataType: EReportDataType.STRING,
      displayName: 'Session country',
    },
    {
      name: 'session_device_os',
      dataType: EReportDataType.STRING,
      displayName: 'Session device OS',
    },
    {
      name: 'online_store_visitors',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors',
    },
    {
      name: 'sessions',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions',
    },
    {
      name: 'bounces',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces',
    },
    {
      name: 'comparison_month__previous_period',
      dataType: EReportDataType.STRING,
      displayName: 'Month (previous_period)',
    },
    {
      name: 'comparison_online_store_visitors__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period)',
    },
    {
      name: 'comparison_sessions__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period)',
    },
    {
      name: 'comparison_bounces__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period)',
    },
    {
      name: 'percent_change_online_store_visitors__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period)',
    },
    {
      name: 'percent_change_sessions__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period)',
    },
    {
      name: 'percent_change_bounces__previous_period',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period)',
    },
    {
      name: 'online_store_visitors__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (session_device_type_month_session_country_totals)',
    },
    {
      name: 'sessions__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (session_device_type_month_session_country_totals)',
    },
    {
      name: 'bounces__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (session_device_type_month_session_country_totals)',
    },
    {
      name: 'comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName:
        'Online store visitors (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'comparison_sessions__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'comparison_bounces__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'online_store_visitors__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (session_device_type_month_totals)',
    },
    {
      name: 'sessions__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (session_device_type_month_totals)',
    },
    {
      name: 'bounces__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (session_device_type_month_totals)',
    },
    {
      name: 'comparison_online_store_visitors__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'comparison_sessions__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'comparison_bounces__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'online_store_visitors__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (session_device_type_totals)',
    },
    {
      name: 'sessions__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (session_device_type_totals)',
    },
    {
      name: 'bounces__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (session_device_type_totals)',
    },
    {
      name: 'comparison_online_store_visitors__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, session_device_type_totals)',
    },
    {
      name: 'comparison_sessions__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_totals)',
    },
    {
      name: 'comparison_bounces__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_totals)',
    },
    {
      name: 'online_store_visitors__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (totals)',
    },
    {
      name: 'sessions__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (totals)',
    },
    {
      name: 'bounces__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (totals)',
    },
    {
      name: 'comparison_online_store_visitors__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, totals)',
    },
    {
      name: 'comparison_sessions__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, totals)',
    },
    {
      name: 'comparison_bounces__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, totals)',
    },
    {
      name: 'percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName:
        'Online store visitors (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'percent_change_sessions__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'percent_change_bounces__previous_period__session_device_type_month_session_country_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_month_session_country_totals)',
    },
    {
      name: 'percent_change_online_store_visitors__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'percent_change_sessions__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'percent_change_bounces__previous_period__session_device_type_month_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_month_totals)',
    },
    {
      name: 'percent_change_online_store_visitors__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, session_device_type_totals)',
    },
    {
      name: 'percent_change_sessions__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, session_device_type_totals)',
    },
    {
      name: 'percent_change_bounces__previous_period__session_device_type_totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, session_device_type_totals)',
    },
    {
      name: 'percent_change_online_store_visitors__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Online store visitors (previous_period, totals)',
    },
    {
      name: 'percent_change_sessions__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Sessions (previous_period, totals)',
    },
    {
      name: 'percent_change_bounces__previous_period__totals',
      dataType: EReportDataType.INTEGER,
      displayName: 'Bounces (previous_period, totals)',
    },
  ],
  rows: [
    {
      session_device_type: 'desktop',
      month: '2025-06-01',
      session_country: 'United States',
      session_device_os: 'Linux',
      online_store_visitors: '192',
      sessions: '192',
      bounces: '192',
      comparison_month__previous_period: '2024-06-01',
      comparison_online_store_visitors__previous_period: '340',
      comparison_sessions__previous_period: '30',
      comparison_bounces__previous_period: '5',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '192',
      sessions__session_device_type_month_session_country_totals: '192',
      bounces__session_device_type_month_session_country_totals: '192',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '343',
      sessions__session_device_type_month_totals: '350',
      bounces__session_device_type_month_totals: '208',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '34',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '234',
      comparison_sessions__previous_period__session_device_type_totals: '345',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '34534',
      comparison_sessions__previous_period__totals: '233',
      comparison_bounces__previous_period__totals: '234',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-06-01',
      session_country: 'Vietnam',
      session_device_os: 'Windows',
      online_store_visitors: '151',
      sessions: '158',
      bounces: '16',
      comparison_month__previous_period: '2024-06-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '151',
      sessions__session_device_type_month_session_country_totals: '158',
      bounces__session_device_type_month_session_country_totals: '16',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '343',
      sessions__session_device_type_month_totals: '350',
      bounces__session_device_type_month_totals: '208',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-07-01',
      session_country: 'Vietnam',
      session_device_os: 'Mac OS X',
      online_store_visitors: '234',
      sessions: '234',
      bounces: '3',
      comparison_month__previous_period: '2024-07-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '451',
      sessions__session_device_type_month_session_country_totals: '460',
      bounces__session_device_type_month_session_country_totals: '16',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '679',
      sessions__session_device_type_month_totals: '688',
      bounces__session_device_type_month_totals: '244',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-07-01',
      session_country: 'Vietnam',
      session_device_os: 'Windows',
      online_store_visitors: '217',
      sessions: '226',
      bounces: '13',
      comparison_month__previous_period: '2024-07-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '451',
      sessions__session_device_type_month_session_country_totals: '460',
      bounces__session_device_type_month_session_country_totals: '16',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '679',
      sessions__session_device_type_month_totals: '688',
      bounces__session_device_type_month_totals: '244',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-07-01',
      session_country: 'United States',
      session_device_os: 'Linux',
      online_store_visitors: '228',
      sessions: '228',
      bounces: '228',
      comparison_month__previous_period: '2024-07-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '228',
      sessions__session_device_type_month_session_country_totals: '228',
      bounces__session_device_type_month_session_country_totals: '228',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '679',
      sessions__session_device_type_month_totals: '688',
      bounces__session_device_type_month_totals: '244',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-08-01',
      session_country: 'Vietnam',
      session_device_os: 'Mac OS X',
      online_store_visitors: '38',
      sessions: '38',
      bounces: '3',
      comparison_month__previous_period: '2024-08-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '40',
      sessions__session_device_type_month_session_country_totals: '40',
      bounces__session_device_type_month_session_country_totals: '3',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '70',
      sessions__session_device_type_month_totals: '70',
      bounces__session_device_type_month_totals: '33',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-08-01',
      session_country: 'Vietnam',
      session_device_os: 'Windows',
      online_store_visitors: '2',
      sessions: '2',
      bounces: '0',
      comparison_month__previous_period: '2024-08-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '40',
      sessions__session_device_type_month_session_country_totals: '40',
      bounces__session_device_type_month_session_country_totals: '3',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '70',
      sessions__session_device_type_month_totals: '70',
      bounces__session_device_type_month_totals: '33',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-08-01',
      session_country: 'United States',
      session_device_os: 'Linux',
      online_store_visitors: '30',
      sessions: '30',
      bounces: '30',
      comparison_month__previous_period: '2024-08-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '30',
      sessions__session_device_type_month_session_country_totals: '30',
      bounces__session_device_type_month_session_country_totals: '30',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '70',
      sessions__session_device_type_month_totals: '70',
      bounces__session_device_type_month_totals: '33',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'desktop',
      month: '2025-09-01',
      session_country: 'Vietnam',
      session_device_os: 'Mac OS X',
      online_store_visitors: '1',
      sessions: '4',
      bounces: '1',
      comparison_month__previous_period: '2024-09-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '1',
      sessions__session_device_type_month_session_country_totals: '4',
      bounces__session_device_type_month_session_country_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '1',
      sessions__session_device_type_month_totals: '4',
      bounces__session_device_type_month_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '1090',
      sessions__session_device_type_totals: '1112',
      bounces__session_device_type_totals: '486',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'mobile',
      month: '2025-06-01',
      session_country: 'Vietnam',
      session_device_os: 'Android',
      online_store_visitors: '1',
      sessions: '1',
      bounces: '1',
      comparison_month__previous_period: '2024-06-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '1',
      sessions__session_device_type_month_session_country_totals: '1',
      bounces__session_device_type_month_session_country_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '1',
      sessions__session_device_type_month_totals: '1',
      bounces__session_device_type_month_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '15',
      sessions__session_device_type_totals: '27',
      bounces__session_device_type_totals: '11',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'mobile',
      month: '2025-07-01',
      session_country: 'Vietnam',
      session_device_os: 'Android',
      online_store_visitors: '3',
      sessions: '12',
      bounces: '8',
      comparison_month__previous_period: '2024-07-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '14',
      sessions__session_device_type_month_session_country_totals: '23',
      bounces__session_device_type_month_session_country_totals: '8',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '14',
      sessions__session_device_type_month_totals: '23',
      bounces__session_device_type_month_totals: '8',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '15',
      sessions__session_device_type_totals: '27',
      bounces__session_device_type_totals: '11',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'mobile',
      month: '2025-07-01',
      session_country: 'Vietnam',
      session_device_os: 'iOS',
      online_store_visitors: '11',
      sessions: '11',
      bounces: '0',
      comparison_month__previous_period: '2024-07-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '14',
      sessions__session_device_type_month_session_country_totals: '23',
      bounces__session_device_type_month_session_country_totals: '8',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '14',
      sessions__session_device_type_month_totals: '23',
      bounces__session_device_type_month_totals: '8',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '15',
      sessions__session_device_type_totals: '27',
      bounces__session_device_type_totals: '11',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'mobile',
      month: '2025-08-01',
      session_country: 'Vietnam',
      session_device_os: 'Android',
      online_store_visitors: '1',
      sessions: '1',
      bounces: '1',
      comparison_month__previous_period: '2024-08-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '1',
      sessions__session_device_type_month_session_country_totals: '1',
      bounces__session_device_type_month_session_country_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '1',
      sessions__session_device_type_month_totals: '1',
      bounces__session_device_type_month_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '15',
      sessions__session_device_type_totals: '27',
      bounces__session_device_type_totals: '11',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: 'mobile',
      month: '2025-09-01',
      session_country: 'Vietnam',
      session_device_os: 'Android',
      online_store_visitors: '1',
      sessions: '2',
      bounces: '1',
      comparison_month__previous_period: '2024-09-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '1',
      sessions__session_device_type_month_session_country_totals: '2',
      bounces__session_device_type_month_session_country_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '1',
      sessions__session_device_type_month_totals: '2',
      bounces__session_device_type_month_totals: '1',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '15',
      sessions__session_device_type_totals: '27',
      bounces__session_device_type_totals: '11',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2024-11-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2023-11-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2024-12-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2023-12-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-01-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-01-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-02-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-02-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-03-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-03-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-04-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-04-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-05-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-05-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-10-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-10-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
    {
      session_device_type: null,
      month: '2025-11-01',
      session_country: null,
      session_device_os: null,
      online_store_visitors: '0',
      sessions: '0',
      bounces: '0',
      comparison_month__previous_period: '2024-11-01',
      comparison_online_store_visitors__previous_period: '0',
      comparison_sessions__previous_period: '0',
      comparison_bounces__previous_period: '0',
      percent_change_online_store_visitors__previous_period: null,
      percent_change_sessions__previous_period: null,
      percent_change_bounces__previous_period: null,
      online_store_visitors__session_device_type_month_session_country_totals: '0',
      sessions__session_device_type_month_session_country_totals: '0',
      bounces__session_device_type_month_session_country_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        '0',
      comparison_sessions__previous_period__session_device_type_month_session_country_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_session_country_totals: '0',
      online_store_visitors__session_device_type_month_totals: '0',
      sessions__session_device_type_month_totals: '0',
      bounces__session_device_type_month_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_month_totals: '0',
      comparison_sessions__previous_period__session_device_type_month_totals: '0',
      comparison_bounces__previous_period__session_device_type_month_totals: '0',
      online_store_visitors__session_device_type_totals: '0',
      sessions__session_device_type_totals: '0',
      bounces__session_device_type_totals: '0',
      comparison_online_store_visitors__previous_period__session_device_type_totals: '0',
      comparison_sessions__previous_period__session_device_type_totals: '0',
      comparison_bounces__previous_period__session_device_type_totals: '0',
      online_store_visitors__totals: '1105',
      sessions__totals: '1139',
      bounces__totals: '497',
      comparison_online_store_visitors__previous_period__totals: '0',
      comparison_sessions__previous_period__totals: '0',
      comparison_bounces__previous_period__totals: '0',
      percent_change_online_store_visitors__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_sessions__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_bounces__previous_period__session_device_type_month_session_country_totals:
        null,
      percent_change_online_store_visitors__previous_period__session_device_type_month_totals: null,
      percent_change_sessions__previous_period__session_device_type_month_totals: null,
      percent_change_bounces__previous_period__session_device_type_month_totals: null,
      percent_change_online_store_visitors__previous_period__session_device_type_totals: null,
      percent_change_sessions__previous_period__session_device_type_totals: null,
      percent_change_bounces__previous_period__session_device_type_totals: null,
      percent_change_online_store_visitors__previous_period__totals: null,
      percent_change_sessions__previous_period__totals: null,
      percent_change_bounces__previous_period__totals: null,
    },
  ],
};
